import React from "react";
import useIdleTimeout from "../hooks/useIdleTimeout";
import AccessPINOverlay from "./AccessPINModal";
import { useIdleContext } from "../context/IdleContext";

/**
 * While locked, do not mount protected app UI — only the PIN screen.
 * An overlay on top of live content is not a lock (DevTools can remove it).
 */
const IdleTimeoutWrapper = ({ children }) => {
  useIdleTimeout(900000);
  const { showIdleModal } = useIdleContext();

  if (showIdleModal) {
    return <AccessPINOverlay listenToIdle />;
  }

  return children;
};

export default IdleTimeoutWrapper;
